<!-- Beautiful Video Demo Section -->
<section class="video-section" id="demo">
  <div class="section-container">
    <div class="section-header">
      <h2 class="section-title">See Tenjah School in Action</h2>
      <p class="section-subtitle">
        Discover how our platform transforms educational management
      </p>
    </div>
    <div class="video-container">
      <!-- Video Thumbnail (shown when not playing) -->
      <div class="video-wrapper" *ngIf="!isPlaying" (click)="playMainVideo()">
        <div class="video-thumbnail">
          <div class="play-button-large">
            <div class="play-icon-large">▶</div>
            <div class="play-ripple"></div>
          </div>
          <div class="video-overlay">
            <div class="overlay-content">
              <h3 class="video-title">Platform Overview</h3>
              <p class="video-description">Complete walkthrough of all features</p>
              <div class="video-duration">
                <span class="duration-icon">⏱️</span>
                <span>3:24</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Actual Video Player (shown when playing) -->
      <div class="video-player-wrapper" *ngIf="isPlaying">
        <div class="video-controls">
          <button class="close-video-btn" (click)="closeVideo()" type="button">
            <span>✕</span>
          </button>
        </div>
        <video
          #videoElement
          class="video-element"
          [src]="videoPath"
          controls
          autoplay
          muted
          playsinline
          preload="metadata">
          <p>Your browser doesn't support HTML5 video. Here is a <a [href]="videoPath">link to the video</a> instead.</p>
        </video>
      </div>
    </div>
  </div>
</section>